import { useMemo } from "react";
import type { ICartDishItem } from "@/types";
import type {
  ICartDishCardVm,
  IMenuItemForCart,
} from "@/components/cart/helpers/mapCartDishToCardVm";
import { mapCartDishToCardVm } from "@/components/cart/helpers/mapCartDishToCardVm";

type DetailsMap = ReadonlyMap<number, IMenuItemForCart | null>;

interface UseCartCardsViewModelArgs {
  cartItems: ICartDishItem[];
  detailsMap: DetailsMap;
  currency: string;
}

export const useCartCardsViewModel = ({
  cartItems,
  detailsMap,
  currency,
}: UseCartCardsViewModelArgs) => {
  const cards: ICartDishCardVm[] = useMemo(() => {
    return cartItems.map((cartItem) => {
      const menuItem = detailsMap.get(cartItem.dishId) ?? null;
      return mapCartDishToCardVm(cartItem, menuItem, currency);
    });
  }, [cartItems, detailsMap, currency]);

  const total = useMemo(() => {
    const rawTotal = cards.reduce((sum, card) => sum + card.totalPrice, 0);
    return Math.round(rawTotal * 100) / 100;
  }, [cards]);

  const totalText = `${total.toFixed(2)} ${currency}`;

  return { cards, total, totalText };
};
